import { useEffect, useLayoutEffect } from "react";

import { analytics } from "@moodys/federated";
import { config } from "config";
import { useInjectCloudwatchRum } from "hooks/useInjectCloudwatchRum";
import { initAvo } from "services/analytics/Avo";

import { getErrorPageDigitalData } from "../../utils/digitalData/digitalData";
import { useAvoTracking } from "../useAvoTracking";
import { useInjectAdobeAnalytics } from "../useInjectAdobeAnalytics";
import { useInjectQualtrics } from "../useInjectQualtrics";
import { useInjectWalkme } from "../useInjectWalkme";
import { useUserInfo } from "../useUserInfo/useUserInfo";

if (!window.liveagent) {
  require("scripts/salesforce-live-chat-deployment.js");
}

export const useGlobalSetup = (isLegacy: boolean) => {
  useInjectAdobeAnalytics(config.ADOBE_DTM_URL);
  useInjectWalkme();
  useInjectQualtrics();
  useInjectWalkme();
  useInjectCloudwatchRum();

  const { trackPageLoad } = useAvoTracking();
  const { userId } = useUserInfo();

  const pageIsErrorOrNotFound =
    location.pathname === config.ROUTES.ERROR ||
    location.pathname === config.ROUTES.NOT_FOUND;

  useLayoutEffect(() => {
    analytics.setupDigitalAnalytics({
      localCopyOfInitAvo: initAvo,
    });
  }, []);

  useEffect(() => {
    if (userId) {
      analytics.emitAnalyticsEvent(
        analytics.AnalyticsEvent.UpdateUserId,
        userId
      );

      if (isLegacy) {
        trackPageLoad();
      }

      if (pageIsErrorOrNotFound) {
        trackPageLoad(getErrorPageDigitalData());
      }
    }
  }, [isLegacy, userId, pageIsErrorOrNotFound]);
};
